module.exports = __webpack_public_path__ + "img/metasalute-logo.16523c3a.jpg";